import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Layout from "../components/layout";
import "../styles/TicketDetails.css";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";

const TicketDetails = () => {
  const { ticket_id } = useParams();
  const [messages, setMessages] = useState([]);
  const [ticketInfo, setTicketInfo] = useState({});
  const [ticketStatus, setTicketStatus] = useState("");
  const [newMessage, setNewMessage] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  const isAdmin = useSelector((state) => state.user.user?.type === "Admin");

  useEffect(() => {
    fetchMessages();
    fetchTicketInfo();
  }, [ticket_id]);

  const fetchMessages = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/messages/${ticket_id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const result = await response.json();
      if (result.success) {
        setMessages(result.data);
      }
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };

  const fetchTicketInfo = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/tickets/${ticket_id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const result = await response.json();
      if (result.success) {
        setTicketInfo(result.data);
        setTicketStatus(result.data.status);
      }
    } catch (error) {
      console.error("Error fetching ticket information:", error);
    }
  };

  const getFileName = (filePath) => {
    if (!filePath) return null;
    return filePath.split("/").pop();
  };

  const getFileUrl = (filePath) => {
    if (!filePath) return null;
    return `http://aga-test.esia.mg/data/files/${getFileName(filePath)}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newMessage) {
      toast.error("Please enter a message.");
      return;
    }

    const formData = new FormData();
    formData.append("message", newMessage);
    formData.append("ticketId", ticket_id);
    if (selectedFile) {
      formData.append("files", selectedFile);
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/sendMessage`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: formData,
        }
      );

      const result = await response.json();
      if (result.success) {
        setNewMessage("");
        setSelectedFile(null);
        fetchMessages();
        toast.success("Message sent successfully!");
      } else {
        toast.error("Failed to send the message.");
      }
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error("An error occurred while sending the message.");
    }
  };

  return (
    <Layout>
      <div className="ticket-details-page">
        <div className="container">
          <h1 className="page-title">Ticket #{ticket_id}</h1>
          <div className="ticket-header">
            <div className="ticket-info">
              <p className="ticket-status">Catégorie: {ticketInfo.category}</p>
              <p className="ticket-status">
                Société: {ticketInfo.company_name}
              </p>
              <p className="ticket-status">
                Status:
                <span className={`status-label ${ticketStatus}`}>
                  {ticketStatus === "in-progress"
                    ? "En Cours"
                    : ticketStatus === "closed"
                    ? "Fermé"
                    : ticketStatus === "open"
                    ? "Ouvert"
                    : "En attente"}
                </span>
              </p>
            </div>
          </div>

          <div className="messages-section">
            {messages.map((message) => (
              <div key={message.id} className="message-card">
                <div className="message-header">
                  <div className="message-sender">
                    {message.company_name}{" "}
                    <span className="message-date">
                      {new Date(message.created_at).toLocaleString()}
                    </span>
                  </div>
                </div>
                <p className="message-text">{message.message}</p>

                {message.file_path && (
                  <div className="file-preview">
                    <a
                      href={getFileUrl(message.file_path)}
                      download={getFileName(message.file_path)}
                    >
                      📎 {getFileName(message.file_path)}
                    </a>
                  </div>
                )}
              </div>
            ))}
          </div>

          <form className="message-form" onSubmit={handleSubmit}>
            <textarea
              className="message-input"
              rows="4"
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              placeholder="Tapez votre message ici ..."
            ></textarea>
            <div className="file-upload-section">
              <label className="file-upload-label">Importer un fichier:</label>
              <input
                type="file"
                className="file-upload-input"
                onChange={(e) => setSelectedFile(e.target.files[0])}
              />
            </div>
            <button type="submit" className="send-button">
              Envoyer
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default TicketDetails;
